import "./App.css";
import React, { useEffect } from "react";
import { MultiStepForm } from "../components/MultiStepForm";
// import "./index.css";

function App() {
  return (
    <div className="flex justify-center mx-auto h-85% overflow-hidden">
      <MultiStepForm />
    </div>
  );
}

export default App;
